import { request as __request } from '../core/request';
export class FrontendOffDatePlanService {
    /**
     * [BASE] Search From OffDatePlanEntity
     * @returns any Success
     * @throws ApiError
     */
    static findAll({ where, page, }) {
        return __request({
            method: 'GET',
            path: `/api/frontend/off_date_plan`,
            query: {
                'where': where,
                'page': page,
            },
        });
    }
    /**
     * [BASE] Batch Update To OffDatePlanEntity
     * @returns void
     * @throws ApiError
     */
    static batchUpdate({ requestBody, }) {
        return __request({
            method: 'PUT',
            path: `/api/frontend/off_date_plan`,
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * [BASE] FindOne From OffDatePlanEntity
     * @returns any Success
     * @throws ApiError
     */
    static findOne({ id, }) {
        return __request({
            method: 'GET',
            path: `/api/frontend/off_date_plan/${id}`,
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
